import React, { useState,useEffect } from "react";
import { AdjustmentsVerticalIcon } from "@heroicons/react/24/outline";
import DatePicker from "react-tailwindcss-datepicker";
import UserLeadsTable from "./tables/UserLeadsTable";
import DropDownFilters from "./DropDownFilters";
import { useGetAllLeadsQuery,useLazyGetAllLeadsQuery } from "../../../../store/admin/leads";


const LeadsPage = () => {
  const [allLeadsData,setAllLeadsData] = useState()
  const [filterActive, setFilterActive] = useState(false);
  const [value, setValue] = useState({
    startDate: null,
    endDate: null,
  });

  const {data: allLeads,isLoading:allLeadsLoader} = useGetAllLeadsQuery()
  const [refetch,{data:refetchData,isLoading:allLeadsRefetchLoader,isFetching}] = useLazyGetAllLeadsQuery()

  useEffect(() => {
    if (allLeads) {
      setAllLeadsData(JSON.parse(JSON.stringify(allLeads)));
    }
  }, [allLeads]);
  
  useEffect(() => {
    if (refetchData) {
      setAllLeadsData(JSON.parse(JSON.stringify(refetchData)));
    }
  }, [refetchData]);

  useEffect(()=>{
    if(isFetching){
      setAllLeadsData({})
    }
  },[isFetching])

  const handleValueChange = (newValue) => {
    setValue(newValue);
  };

  const handleProfessionalFilter = () => {
    setFilterActive((prevState) => !prevState);
  };

  return (
    <div className="col-span-12">
      <div className="flex justify-between items-start md:items-center flex-col md:flex-row gap-5 mb-5">
        <h3 className="text-xl leading-[160%] font-bold text-[#04091E]">
          Leads
        </h3>
        <div className="flex items-start md:items-center gap-3.5 md:gap-[30px] flex-col md:flex-row md:max-w-[360px] justify-between w-full relative">
          <div className="rounded-md custom-date-picker md:max-w-[282px] w-full">
            <DatePicker
              primaryColor={"blue"}
              toggleClassName="hidden"
              // useRange={false}
              // asSingle={true}
              value={value}
              onChange={handleValueChange}
              displayFormat={"MM/DD/YYYY"}
              showShortcuts={true}
            />
          </div>
          <button
            className={`w-full md:w-12 h-12 flex items-center justify-center gap-2.5 md:gap-0 rounded-[10px] ${
              filterActive
                ? "bg-[#D2ECFF] text-primary"
                : "bg-[#EBEFF3] text-[#485868]"
            }`}
            onClick={handleProfessionalFilter}
          >
            <AdjustmentsVerticalIcon className="w-6 h-6 text-[#485868]" />
            <span
              className={`text-sm font-bold leading-[160%] text-[#485868] block md:hidden ${
                filterActive ? "text-primary" : "text-[#485868]"
              }`}
            >
              Filter
            </span>
          </button>
          <div
            className={`notificationDropdown absolute right-0 top-[55px] md:top-[60px] z-[380] opacity-0 ${
              filterActive ? "notificationOpen" : ""
            }`}
          >
            <DropDownFilters
              setFilterActive={setFilterActive}
              filterActive={filterActive}
              setCreditRenewal={false}
            />
          </div>
        </div>
      </div>
      <UserLeadsTable leadData={allLeadsData} getUpdateData={refetch} />
    </div>
  );
};

export default LeadsPage;
